export enum PrinterActionsEnum {
  None = '',
  Eject = 'E',
  Retract = "R"
}
